<template>
  <div class="vistaScada">
   <div>SCADA</div>
    

  </div>
</template>

<script>


export default {
  components: {
    
    
  },
};
</script>

<style>
 
</style>